function openPositions() {
    if ( $('.open-positions__list').length ) {

        const departmentSelect = document.getElementById('department-select');
        const locationSelect = document.getElementById('location-select');

        fetch('https://boards-api.greenhouse.io/v1/boards/pivotbio/departments')
        .then(response => response.json())
        .then(data => {
            // Function to parse departments based on selected department and location filters
            function parseDepartments(departmentFilters = [], locationFilters = []) {
                return data.departments
                .filter(dept => {
                    const childDepartments = dept.child_ids.map(childId =>
                        data.departments.find(d => d.id === childId)
                    );

                    // Filter child departments that have jobs matching the filters
                    const filteredChildDepartments = childDepartments.filter(childDept => {
                        if (childDept && childDept.jobs.length > 0) {
                            childDept.filteredJobs = childDept.jobs.filter(job => 
                                (!locationFilters.length || locationFilters.some(loc => job.location.name.includes(loc)))
                            );
                            return childDept.filteredJobs.length > 0 &&
                                (!departmentFilters.length || departmentFilters.some(deptFilter => childDept.name.includes(deptFilter)));
                        }
                        return false;
                    });

                    // Check if the parent department has jobs matching the filter
                    const hasMatchingJobs = dept.jobs.length > 0 &&
                        (!departmentFilters.length || departmentFilters.some(deptFilter => dept.name.includes(deptFilter))) &&
                        (!locationFilters.length || dept.jobs.some(job => locationFilters.some(loc => job.location.name.includes(loc))));

                    if (filteredChildDepartments.length > 0 || hasMatchingJobs) {
                        dept.filteredChildren = filteredChildDepartments;
                        return true;
                    }
                    return false;
                });
            }

            // Create HTML for job listings
            function createJobListHTML(jobs) {
                if (!jobs || jobs.length === 0) return '';

                let jobList = '<ul class="job-list">';
                jobs.forEach(job => {
                    jobList += `
                        <li>
                            <a href="${job.absolute_url}" target="_blank">${job.title} <span>${job.location.name}</span></a>
                        </li>
                    `;
                });
                jobList += '</ul>';
                return jobList;
            }

            // Function to render departments and child departments
            function renderDepartments(departments) {
                const container = document.querySelector('.open-positions__list');
                container.innerHTML = '';

                if (departments.length) {
                    departments.forEach(dept => {
                        // Create parent department element
                        const parentDeptHTML = document.createElement('div');
                        parentDeptHTML.classList.add('open-position__category');
                        parentDeptHTML.innerHTML = `<h2>${dept.name}</h2>`;

                        // Append child departments that have jobs
                        dept.filteredChildren.forEach(childDept => {
                            const childDeptHTML = document.createElement('ul');
                            childDeptHTML.classList.add('department-list');
                            childDeptHTML.innerHTML = `
                                <li>
                                    <h3>${childDept.name}</h3>
                                    ${createJobListHTML(childDept.filteredJobs)}
                                </li>
                            `;

                            parentDeptHTML.appendChild(childDeptHTML);
                        });

                        // Only append the parent department if there are child departments with jobs
                        if (dept.filteredChildren.length > 0) {
                            container.appendChild(parentDeptHTML);
                        }
                    });
                } else {
                    container.innerHTML = '<h3>No results found</h3>';
                }
            }

            // Function to populate the department and location dropdowns
            function populateDropdowns(departments) {
                const departmentSet = new Set();
                const locationSet = new Set();

                // Populate dropdown sets with unique values
                departments.forEach(dept => {
                    dept.filteredChildren.forEach(childDept => {
                        departmentSet.add(childDept.name);
                        childDept.filteredJobs.forEach(job => {
                            locationSet.add(job.location.name);
                        });
                    });
                });

                // Populate the department dropdown
                departmentSet.forEach(department => {
                    const option = document.createElement('option');
                    option.value = department;
                    option.text = department;
                    departmentSelect.appendChild(option);
                });

                // Populate the location dropdown
                locationSet.forEach(location => {
                    const option = document.createElement('option');
                    option.value = location;
                    option.text = location;
                    locationSelect.appendChild(option);
                });
            }

            // Show all departments/child departments with jobs
            let initialLoad = true;
            function loadAllDepartments() {
                const departmentsWithJobs = parseDepartments();
                renderDepartments(departmentsWithJobs);

                if (initialLoad) {
                    populateDropdowns(departmentsWithJobs);
                }
                initialLoad = false;
            }
            loadAllDepartments();

            $('#department-select, #location-select').each(function() {
                const $this = $(this),
                      placeholder = $this.attr('placeholder');
    
                $this.select2MultiCheckboxes({
                    width: 'resolve',
                    templateSelection: function() {
                        return placeholder;
                    }
                });
            });
    
            $('#department-select, #location-select').on('select2:select select2:unselect', function (e) {
                const $departmentSelect = $('#department-select'),
                      $locationSelect = $('#location-select'),
                      departments = ($departmentSelect.val()) ? $departmentSelect.val() : new Array(),
                      locations = ($locationSelect.val()) ? $locationSelect.val() : new Array();

                if (locations.length || departments.length) {
                    const filteredDepartments = parseDepartments(departments, locations);
                    renderDepartments(filteredDepartments);
                } else {
                    loadAllDepartments();
                }
            });
        })
        .catch(error => {
            console.error('Error fetching jobs:', error);
        });
    }

}